import React, { createContext, useState, useContext } from 'react';
import HowlerPlayer from './howlerPlayer/Howlerplayer';

// Create context
const AudioPlayerContext = createContext();

// Provider component
export const AudioPlayerProvider = ({ children }) => {
  const [currentAudio, setCurrentAudio] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [showPlayer, setShowPlayer] = useState(false);

  const playAudio = (audioData) => {
    setCurrentAudio(audioData);
    setShowPlayer(true);
    setIsPlaying(true);
  };

  const closePlayer = () => {
    setShowPlayer(false);
    setIsPlaying(false);
  };

  return (
    <AudioPlayerContext.Provider 
      value={{ 
        currentAudio, 
        isPlaying, 
        playAudio, 
        closePlayer,
        setIsPlaying 
      }}
    >
      {children}
      
      {/* Persistent Player - remains mounted across page changes */}
      {showPlayer && currentAudio && (
        <div className="fixed-player-container">
          <HowlerPlayer
            audio={currentAudio}
            isPlaying={isPlaying}
            setIsPlaying={setIsPlaying}
            onClose={closePlayer}
          />
        </div>
      )}
    </AudioPlayerContext.Provider>
  );
};

// Custom hook to use the audio player context
export const useAudioPlayer = () => useContext(AudioPlayerContext);